module.exports = __webpack_public_path__ + "img/3.18e3a7ab.jpg";